import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { VisorgisService } from '../../services/visorgis.service';
import { Subscription } from 'rxjs';
import { VisorgisComponent } from '../../visorgis.component';

import {
  MatDrawer,
  MatDrawerContainer,
  MatDrawerContent,
  MatSidenav,
} from '@angular/material/sidenav';
import { ModalGisComponent } from '../modal-gis/modal-gis.component';
import { ModalFormComponent } from '../../../../shared/components/modal-form/modal-form.component';
import { ModalLeafletDrawComponent } from '../modal-leaflet-draw/modal-leaflet-draw.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-gis',
  templateUrl: './gis.component.html',
  styleUrls: ['./gis.component.scss'],
  imports: [
    VisorgisComponent,
    MatDrawerContainer,
    MatDrawerContent,
    MatDrawer,
    ModalGisComponent,
    ModalFormComponent,
    ModalLeafletDrawComponent,
    RouterModule,
  ],
})
export class GisComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('drawer') drawer: MatDrawer;
  on4sig = false;
  obs$: Subscription;
  fullRendered = false; // variable para saber si el componente ya se renderizo en pantalla
  opened_menu_filtros = false;
  component = 'leaflet-draw-parcela';

  constructor(private service: VisorgisService) {}

  ngOnInit(): void {
    // mostrar que se inicio el componente
    this.obs$ = this.service.isOn4sig().subscribe(res => {
      this.on4sig = res;
    });
    this.service.getMenuState().subscribe(res => {
      this.opened_menu_filtros = res;
    });
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.fullRendered = true;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class
    console.log('se destruyo el modulo');
  }

  onCloseDrawer(): void {
    this.service.setMenuState(false);
  }
}
